<template>
  <div class="guests-current" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule"/>
    <div class="content">
      <div class="item" v-for="(item,index) in guests" :key="index">
        <div class="guest-photo-box">
          <!-- <img src="https://summit-img.geekpark.net/example/cur-guests.png" alt=""> -->
          <img :src="item.avator.url" alt="">
          <span class="guest-name">{{item.name}}</span>
        </div>
        <p class="guest-info">
          <span>{{item.company}}</span>
          <span>{{item.title}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import ModuleNav from './ModuleNav';
  import { mapState } from 'vuex';

  export default {
    name: 'GuestsCurrent',
    components: { ModuleNav },
    computed: {
      ...mapState({
        backGroundImage: state => state.guestsCurrent.backGroundImage,
        nav: state => state.guestsCurrent.nav,
      }),
      guests() {
        return this.$store.state.global.guests.filter(item => item.speech === null);
      }
    },
    data() {
      return {
        isInModule: false,
      };
    },
    methods: {
      mouseEnter() {
        this.isInModule = true;
      },
      mouseLeave() {
        this.isInModule = false;
      }
    }
  };
</script>

<style scoped lang="less">
  .guests-current {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }

  .content {
    width: 215vh;
    height: 86vh;
    margin-left: 3vh;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .item {
    box-sizing: border-box;
    margin: 0 .8vh 2.8vh 0;
    width: 20.5vh;
    height: 26.8vh;
    border: 1px solid #f2f2f2;
    overflow: hidden;
  }

  .guest-photo-box {
    position: relative;
    height: 20vh;
    background: url("https://summit-img.geekpark.net/gpk-meeting-module/3-2-%E6%9C%AC%E5%B1%8A%E5%98%89%E5%AE%BE-%E7%BB%9F%E4%B8%80%E8%83%8C%E6%99%AF.jpg") 0 0/cover;

    img {
      width: 100%;
      height: 20vh;
      position: relative;
    }

    .guest-name {
      position: absolute;
      left: 1vh;
      bottom: .5vh;
      color: #fff;
      font-size: 2vh;
      font-weight: bold;
    }
  }

  .guest-info {
    margin: 1vh 1vh 0;
    text-align: left;
    font-size: 1.5vh;
    font-weight: 500;

    span {
      display: block;
    }

    span:first-of-type {
      color: #ff3c00;

    }

    span:last-of-type {
      color: #1d1d1d;
    }
  }
</style>
